import { Routes, Route, BrowserRouter as Router } from "react-router-dom";

// pages
import Home from "../pages/home";
import Services from "../pages/services";
import About from "../pages/about";
import Contact from "../pages/contact";
import History from "../pages/history";
import EmptyStateMenu from "../components/empty/emptyStateMenu";
const Routers = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/history-job" element={<History />} />
        <Route path="*" element={<EmptyStateMenu />} />{" "}
      </Routes>
    </Router>
  );
};

export default Routers;
